import { ua } from './ua';

/**
 * 是否鸿蒙系统（UserAgent 常见标识）
 * 注意：ua 在 ua.ts 中已 toLowerCase，此处需用小写标识匹配
 */
function isHarmonyUA(): boolean {
    const harmonyMarkers = ['harmonyos', 'ohos', 'openharmony'];
    return harmonyMarkers.some((marker) => ua.includes(marker));
}

/**
 * 是否 Android 系统（含鸿蒙：鸿蒙基于 OpenHarmony，UA 可能无 android 字样，故一并归入）
 */
export const isAndroid = /android/i.test(ua) || isHarmonyUA();

/**
 * 是否iOS系统
 */
export const isIos =
    (ua && /(iphone|ipad|ipod|ios)/i.test(ua)) ||
    (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints > 1 || 'ontouchstart' in window)); // iPadOS13

/**
 * 是否Windows系统
 */
export const isWin = /win/i.test(navigator.platform);

/**
 * 是否Mac系统
 */
export const isMac = /mac/i.test(navigator.platform);

/**
 * 获取iOS系统版本
 */
export const iosVersion = (() => {
    const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    let version: number[];
    if (isIos && match !== undefined && match !== null) {
        version = [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || '0', 10)];
        return parseFloat(version.join('.'));
    }
    return 0;
})();

/**
 * 是否鸿蒙系统（需单独区分鸿蒙时使用；否则可直接用 isAndroid）
 */
export function isHarmonyOS(): boolean {
    return isHarmonyUA();
}
